<template>
  <div>
    <v-toolbar
      flat
      dense
    >
      <v-toolbar-items>
        <v-btn
          outlined
          color="primary"
          @click=""
        >
          <v-icon left>mdi-keyboard-f1</v-icon>
          <span>Descarga subsidio</span>
        </v-btn>
        <v-btn
          outlined
          color="primary"
          @click=""
        >
          <v-icon left>mdi-keyboard-f2</v-icon>
          <span>Nuevo pago</span>
        </v-btn>
        <v-btn
          outlined
          color="primary"
          @click=""
        >
          <v-icon left>mdi-keyboard-f3</v-icon>
          <span>Nueva venta</span>
        </v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click=""
            >
              <v-icon>mdi-cash-sync</v-icon>
            </v-btn>
          </template>
          <span>F6 Recalcular saldo</span>
        </v-tooltip>
        <v-tooltip
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click=""
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>F7 Editar cuenta</span>
        </v-tooltip>
        <v-tooltip
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-printer</v-icon>
            </v-btn>
          </template>
          <span>F4 Imprimir deuda</span>
        </v-tooltip>
        <v-tooltip
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            outlined
            color="primary"
            v-bind="attrs"
            v-on="on"
            >
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>
        </template>
        <span>F8 Imputaciones</span>
      </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>
    <cuentas-edit v-model="dialogEditCuenta" />
    <creditos-subsidio v-model="dialogCreateSubsidio" />
    <creditos-create v-model="dialogCreateCredito" />
    <debitos-create v-model="dialogCreateDebito" />
    <cuenta-refresh />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResumenPrint from '@/pages/cuentas/PrintComponent'
import CuentasEdit from '@/pages/cuentas/EditComponent'
import DebitosCreate from '@/pages/debitos/CreateComponent'
import CreditosCreate from '@/pages/creditos/CreateComponent'
import CreditosSubsidio from '@/pages/creditos_subsidio/CreateComponent'
import ImputacionesExport from '@/pages/imputaciones/ExportComponent'
import Recalcular from '@/pages/cuentas/RecalcularComponent'
import Refresh from '@/pages/cuentas/RefreshComponent'
import PrecioMixin from '@/mixins/Precios'
export default {
  name: 'SaldosComponent',
  mixins: [PrecioMixin],
  components: {
    'resumen-print': ResumenPrint,
    'cuentas-edit': CuentasEdit,
    'creditos-subsidio': CreditosSubsidio,
    'creditos-create': CreditosCreate,
    'debitos-create': DebitosCreate,
    'recalcular-saldo': Recalcular,
    'cuenta-refresh': Refresh,
    'imputaciones-export': ImputacionesExport
  },
  data () {
    return {
      dialogEditCuenta: false,
      dialogCreateSubsidio: false,
      dialogCreateCredito: false,
      dialogCreateDebito: false,
      drawer: true,
      precio: {
        id: null,
        vigencia: null,
        subsidio: 0,
        usuario: 0,
        pleno: 0,
      }
    }
  },
  beforeMount () {
    // Agrega el event listener en el gancho beforeMount
    window.addEventListener('keydown', this.handleKeyboard);
  },
  beforeDestroy () {
    // Remueve el event listener en el gancho beforeDestroy
    window.removeEventListener('keydown', this.handleKeyboard);
  },
  async created () {
    // this.$nextTick(() => {
    //   this.$refs.autocomplete.focus();
    // });
  },
  computed: {
    ...mapGetters('Cuentas', ['selected', 'selectedId']),
    cuentaSelected () {
      return this.selected && this.selected.id > 0 
    },
    numero () {
      return this.selected.numero
    },
    descripcion () {
      return this.selected.descripcion
    },
    saldoTotal () {
      return this.saldoSinSubsidio + this.saldoUsuario
    },
    saldoSinSubsidio() {
      return this.selected.saldo_pleno + (this.selected.kilos_pleno * this.precio.pleno);
    },
    saldoUsuario() {
      return this.selected.saldo_usuario
    },
    saldoSubsidio() {
      return this.selected.saldo_subsidio
    },
    kilosSubsidio() {
      return this.saldoSubsidio ? (this.saldoSubsidio / this.precio.subsidio) : 0
    },
    kilosPleno() {
      return this.selected.kilos_pleno
    },
    creditoDemas() {
      return this.selected.credito_demas
    },
    inactivo () {
      return this.selected && this.selected.inactivo;
    },
  },
  watch: {
    selectedId() {
      this.precio = this.precioByVigencia(this.$moment().format('YYYY-MM-DD'));
    }
  },
  methods: {
    onNuevoSubsidio (event) {
      event.preventDefault()
      if (this.inactivo) {
        alert('La cuenta está inactiva');
        return;
      }
      this.dialogCreateSubsidio = true
    },
    onNuevoCredito (event) {
      event.preventDefault()
      if (this.inactivo) {
        alert('La cuenta está inactiva');
        return;
      }
      this.dialogCreateCredito = true
    },
    onNuevoDebito (event) {
      event.preventDefault()
      if (this.inactivo) {
        alert('La cuenta está inactiva');
        return;
      }
      this.dialogCreateDebito = true
    },
    onCuentaEdit (event) {
      event.preventDefault()
      this.dialogEditCuenta = true
    },
    onImputaciones(event) {
      event.preventDefault();
      this.$store.dispatch('ImputacionesExport/onSave');
    },
    handleKeyboard(event) {
      // Si Ctrl está presionada, salimos ya que no queremos manejarla aquí
      if (event.ctrlKey) {
        return;
      }
      // Objeto que mapea las teclas a sus funciones correspondientes
      const keyActions = {
        'F1': this.onNuevoSubsidio,
        'F2': this.onNuevoCredito,
        'F3': this.onNuevoDebito,
        'F7': this.onCuentaEdit,
        'F8': this.onImputaciones,
      };
      // Obtenemos la función correspondiente a la tecla presionada
      const action = keyActions[event.key];
      // Si no hay una acción mapeada para esta tecla, salimos
      if (!action) {
        return;
      }
      // Verificamos si hay una cuenta seleccionada antes de ejecutar la acción
      if (!this.cuentaSelected) {
        alert('¡Primero debe seleccionar una cuenta!');
      } else {
        // Ejecutamos la acción (la función) con el contexto correcto (this)
        action.call(this, event);
      }
    },
  },
}
</script>
